<div class="common-popup">
  <div class="custom-close" (click)="close()">
    <img src="../../assets/images/new-close.svg" alt="Close button" />
  </div>
  <div class="select-role">
    <h4>How many spots do you need?</h4>
  </div>
  <ul>
    <li *ngFor="let option of bookingOptions">
      <div class="individual-driver">
        <img [src]="option.img" [alt]="option.alt" />
        <h5>{{ option.title }}</h5>
        <div class="select-btn">
          <p-button
            styleClass="p-button p-button-outlined"
            label="Select"
            (onClick)="routeClick(option.route)"
          ></p-button>
        </div>
      </div>
    </li>
  </ul>
</div>